import styled from "styled-components";

export const _AddToCartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  ${({ hasErrors }) =>
    hasErrors &&
    `
    flex-direction: column;

    @media (min-width: 768px) {
      flex-direction: row;
    }
  `}

  .delivery-information {
    margin-top: 10px;
  }
`;

export const _ErrorContainer = styled.div`
  border: 2px dotted #f07200;
  background-color: #fff;
  padding: 15px;
  margin-left: 30px;

  p,
  a {
    font-size: 14px;
    text-align: left;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  @media (min-width: 480px) {
    .conservatory-guide .order-summary .articles-not-available {
      margin-left: 30px;
      max-width: 600px;
    }
  }
`;

export const _TotalDiscount = styled.span`
  display: block;
  font-size: 18px;
  margin: 5px 0px;
  color: ${({ theme }) => theme.darkGrey};
`;

export const _TermsOfPurchase = styled.a`
  font-size: 12px;
  margin: 2px 0px;
  display: block;
`;

export const _PriceChanges = styled.span`
  display: none;

  @media print {
    display: block;
    width: 100%;
    margin-top: 20px;
    text-align: left;
    margin-left: 60%;
  }
`;
